"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reflect = void 0;
/** Always return null but pretends it returns an object of type T */
function Reflect() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return null;
}
exports.Reflect = Reflect;
//# sourceMappingURL=Reflect.js.map